export const getStudioData = ({ networks }) => networks.networks;
export const getStudioDropDownSelector = ({ networks }) =>
  networks.studioDropDown;
export const getStudioLoading = ({ networks }) => networks.loaders.common;
export const getErrorStudio = ({ networks }) => networks.errors.networks;
